// If component is used to render children based on the condition.
const If = ({ condition, children }) => {
  if (condition) {
    return children;
  }
  return null;
};

export default If;
